export default "<div id=\"map-container\" style=\"height: 100vh;width: 100hv\">\n</div>"